import React, { useState } from 'react';
import { DialogFooter } from '@/Components/shadcn/dialog';
import { Button, Spinner } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';

export interface AssessmentResetDialogActionsProps {
    onConfirm: () => Promise<void>;
    onCancel: () => void;
}

const AssessmentResetDialogActions = ({
    onConfirm,
    onCancel,
}: AssessmentResetDialogActionsProps): React.JSX.Element => {
    const [loading, setLoading] = useState<boolean>(false);
    return (
        <DialogFooter className="gap-2 sm:justify-end">
            <Button variant="outline" disabled={loading} onClick={onCancel}>
                {UIStrings.Cancel}
            </Button>
            <Button
                size="lg"
                disabled={loading}
                onClick={async () => {
                    setLoading(true);
                    try {
                        await onConfirm();
                        onCancel();
                    } finally {
                        setLoading(false);
                    }
                }}
            >
                {loading && <Spinner data-icon="inline-start" />}
                {UIStrings.ResetAssessment}
            </Button>
        </DialogFooter>
    );
};

export default AssessmentResetDialogActions;
